import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import WarningTriangle from '../../../../public/assets/img/warning.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import { TextField, CardContent, Card, Grid, styled, InputAdornment } from '@mui/material';
import { CircularProgressLoader } from '../../../shared/components/Loaders';
import { useDispatch, useSelector } from 'react-redux';
import sevenNowLogo from '../../../../public/assets/img/seven-now-logo.svg';
import CustomPopOver from '../../../shared/pop-over/custom.pop-over';
import { LOGIN_VERBIAGE, EMAIL_VERBIAGE, LOGIN_SUB_TEXT } from '../../../constants/landingConstant';
import { getClearResponse } from '../../../redux/actions/checkmateAuthorizationAction';
import { getAuthUser } from '../../../redux/actions/amazonWebServicesAction';
import { FORGOT_PASSWORD, PRIVACY_POLICY_CONTENT, LOG_IN, USERNAME_EMAIL_REQUIRED, PASSWORD_REQUIRED, MINI_CHAR, PASS_MINI_CHAR, LOG_IN_TITLE, BACK_TEXT, REQ_ACCESS_TEXT, MERCHANT_PORTAL_TEXT, GETTING_STARTED  } from '../../../constants/buttonConstants';
import LoginOtter from '../Login/LoginOtter';
import LoginIACM from '../Login/LoginIACM';
import { setInitialRoute, updateAppOrgName } from '../../../redux/actions/merchantAction';
import { loginResponseSaga } from '../../../redux/saga/loginServiceSelector';
import { authenticateUserRequest, forgetPasswordEmailRequest } from '../../../redux/actions/loginServiceAction';
import { NEXT_TEXT } from '../../../constants/settingsPageConstants';
import { restrictOnlyFewSpecialChara, validateUserNameandEmail } from '../../../shared/utils/format.helpers';
import { LOGIN_FAILED_ERROR, LOGIN_FAILED_TIMEOUT } from '../../../constants/merchantsConstants';
import './Landing.scss';
import { encryptPassword } from '../../../shared/utils/common';
import mixpanel from 'mixpanel-browser';
import { SUCCESS, FAILURE } from '../../../constants/mixPannelConstants';
import { buttonClick_Mixpanel, loginErrorIdentification_Mixpanel, loginOutcome_Mixpanel } from '../../../shared/mixpanel/mixpanel';


const CssTextField = styled(TextField)({
    '& label.Mui-focused': {
        color: '#111111',
        fontWeight: '700'
    },
});

const buttonStyle = {
    backgroundColor: '#E6F1EE',
    borderRadius: '20px',
    borderColor: 'transparent',
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '700',
    height: '40px',
    width: '100%',
    color: '#00563C'
}


const Landing = ({ orgName }) => {

	const dispatch = useDispatch();
    const navigate = useNavigate();
    const [userNameCard, setUserNameCard] = useState(false)
    const [userName, setUserName] = useState('')
    const [password, setPassword] = useState('')
    const [userNameError, setUserNameError] = useState(false)
    const [passwordError, setPasswordError] = useState(false)
    const [userNameErrorMsg, setUserNameErrorMsg] = useState('')
    const [passwordErrorMsg, setPasswordErrorMsg] = useState('')
    const [loginErrorMsg, setloginErrorMsg] = useState('');
    const [formValid, setformValid] = useState(false);
    const [loading, setLoading] = useState(true);
    const [popOverTitle, setpopOverTitle] = useState();
    const [merchantAccountView, setmerchantAccountView] = useState();
    const [listData, setlistData] = useState(null);
    const [listTitle, setlistTitle] = useState('');
    const [listControl, setlistControl] = useState('');
    const [primaryButtonText, setprimaryButtonText] = useState('');
    const [open, setOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState('');
    const [showLowerDescription, setshowLowerDescription] = useState('');
    const [listHeight, setListHeight] = useState('100px');
    const [apiInProgress, setapiInProgress] = useState(false);
    const [emailWord, setEmailWord] = useState('');
    const loginResponseData = useSelector(loginResponseSaga);

    const handleForgotPassword = () => {
        setUserNameCard(true);
    }

    useEffect(() => {
        if (!orgName) {
            dispatch(updateAppOrgName(''));
            sessionStorage.setItem('orgName', '');
            sessionStorage.setItem('merchantAuth', 'false');
            
        } 

        let emailWordText = EMAIL_VERBIAGE;

        emailWordText = emailWordText.replace('[email]', process.env.REQUEST_ACCESS_MAIL);

        setEmailWord(emailWordText);

        // console.log('TEST ', process.env.CLIENT_ID,process.env.CLIENT_SECRET, process.env.OTTER_CLIENT_ID)
    }, [])

    useEffect(() => {
        if (loginResponseData && !orgName) {
            if (loginResponseData?.idToken) {
                setUserNameError(false)
                setPasswordError(false)
                setUserNameErrorMsg('');
                setPasswordErrorMsg('');
                if (loginResponseData.isAdmin) {
                    dispatch(getAuthUser(true))
                    dispatch(setInitialRoute(''))
                    sessionStorage.setItem('isAdmin', true);
                    navigate('/dashboard/adminhomepage');
                } else {
                    dispatch(getAuthUser(true))
                    dispatch(updateAppOrgName(''));
                    dispatch(setInitialRoute(''));
                    sessionStorage.setItem('isAdmin', false);
                    navigate('/dashboard');
                }
            }
            else {
                setapiInProgress(false);
                // console.log('DD ',loginResponseData.details, loginResponseData.details?.data?.message);
                if (loginResponseData.details?.data?.message) {
                    setUserNameError(true)
                    setPasswordError(true)
                    setUserNameErrorMsg(USERNAME_EMAIL_REQUIRED);
                    setPasswordErrorMsg(PASSWORD_REQUIRED);
                    setloginErrorMsg(String(loginResponseData.details?.data?.message))
                } else if(loginResponseData.details?.code === 'ECONNABORTED'){
                    setUserNameError(true)
                    setPasswordError(true)
                    setUserNameErrorMsg(USERNAME_EMAIL_REQUIRED);
                    setPasswordErrorMsg(PASSWORD_REQUIRED);
                    setloginErrorMsg(LOGIN_FAILED_TIMEOUT)
                } else {
                    setUserNameError(true)
                    setPasswordError(true)
                    setUserNameErrorMsg(USERNAME_EMAIL_REQUIRED);
                    setPasswordErrorMsg(PASSWORD_REQUIRED);
                    setloginErrorMsg(LOGIN_FAILED_ERROR)
                }
            }
        }
		if (loginResponseData && loginResponseData.userId) {
			mixpanel.identify(loginResponseData.userId);

			mixpanel.people.set({
				$email: loginResponseData.emailId,
				isAdmin: loginResponseData.isAdmin,
				merchantId: loginResponseData.merchantId,
				$user_id: loginResponseData.userId,
				UserName: loginResponseData.userName
			});

			loginOutcome_Mixpanel(SUCCESS);

		}
		if (loginResponseData && loginResponseData.msg && loginResponseData.msg === 'ERROR' ) {
			//const user = {
			//	userName: JSON.parse(loginResponseData?.details?.config?.data).userName ,
			//	errorMessage: loginResponseData.details?.data?.message,
			//};
			loginOutcome_Mixpanel(FAILURE);
			if (loginResponseData.details?.data?.message) {
				loginErrorIdentification_Mixpanel(loginResponseData.details.data.message);
			} else {
				loginErrorIdentification_Mixpanel(loginResponseData.msg);
			}
		}
    }, [loginResponseData])

    useEffect(() => {
        if (open) {
            setTimeout(() => {
                setLoading(false)
            }, 2000)
        } else {
            setLoading(true)
        }
    }, [open]);

    const handleSubmit = (event) => {
        event.preventDefault()
        if (userNameCard && userName !== '') {
			buttonClick_Mixpanel('next button on forgot password');
            dispatch(forgetPasswordEmailRequest(userName));
            navigate('/changepassword');
        } else {
            handleLogin(event);
        }
    }

    const handleLogin = (e) => {
		buttonClick_Mixpanel('login button on login page');
        e.preventDefault();
        setUserNameError(false)
        setPasswordError(false)
        setUserNameErrorMsg('');
        setPasswordErrorMsg('');
        setloginErrorMsg('');
        dispatch(getClearResponse({}))
        validation().then((res) => {
            if (res.userName === '' && res.password === '') {
                setapiInProgress(true);
                const encryptedPassword = encryptPassword(password);
                dispatch(authenticateUserRequest(userName, encryptedPassword));
            }
        }, err => {
            setapiInProgress(false);
            console.log(err)
        })
            .catch(err => {
                setapiInProgress(false);
                console.log(err)
            });
    }

    const validation = () => {
        return new Promise((resolve, reject) => {
            if (userName === '' && password === '') {
                setUserNameError(true)
                setPasswordError(true)
                setUserNameErrorMsg(USERNAME_EMAIL_REQUIRED);
                setPasswordErrorMsg(PASSWORD_REQUIRED);
                resolve({ userName: USERNAME_EMAIL_REQUIRED, password: PASSWORD_REQUIRED });
            }
            else if (userName === '') {
                setUserNameError(true)
                setUserNameErrorMsg(USERNAME_EMAIL_REQUIRED)
                resolve({ userName: USERNAME_EMAIL_REQUIRED, password: '' });
            }
            else if (password === '') {
                setPasswordError(true)
                setPasswordErrorMsg(PASSWORD_REQUIRED)
                resolve({ userName: '', password: PASSWORD_REQUIRED });
            }
            else if (password.length < 6) {
                setPasswordError(true)
                setPasswordErrorMsg(MINI_CHAR)
                resolve({ userName: '', password: PASS_MINI_CHAR });
            }
            else {
				setUserNameError(false);
				setPasswordError(false);
				setUserNameErrorMsg('');
				setPasswordErrorMsg('');
                resolve({ userName: '', password: '' });
            }
        });
    };

	const navigateToGetStartedPage = () => {
		buttonClick_Mixpanel('get started button on login page');
		navigate('/getstarted');
	};

    const termsOfUseHandler = (e) => {
        window.open(process.env.TERMS_URL, '_blank');
        // window.open('/terms', '_blank');
        e.preventDefault();
    }

    const privacyPolicyHandler = (e) => {
        window.open(process.env.PRIVACY_URL, '_blank');
        e.preventDefault();
    }

    const handleClose = (value) => {
        setOpen(false);
    };

    const validateFormUserName = (value) => {
        setUserNameError(!validateUserNameandEmail(value))
        setUserNameErrorMsg(validateUserNameandEmail(value) ? '' : USERNAME_EMAIL_REQUIRED )
        setUserName(value);
    }

    const validateFormPassword = (value) => {
        setPasswordError(!restrictOnlyFewSpecialChara(value))
        setPasswordErrorMsg(restrictOnlyFewSpecialChara(value) ? '' : PASSWORD_REQUIRED)
        setPassword(value);
    }

    useEffect(()=>{
        if(userNameCard){
            setformValid(userName !== '' && restrictOnlyFewSpecialChara(userName));
        } else {
            setformValid(userName !== '' && restrictOnlyFewSpecialChara(userName) && password !== '' && restrictOnlyFewSpecialChara(password));
        }
    },[userName, password]);

    const card = (
        <CardContent className='login-card'>
            <form className='display-grid' autoComplete='off' onSubmit={handleSubmit}>
                {userNameCard ?
                    <>
                        <p className='marginbottom24 forgot-password-field'> {FORGOT_PASSWORD}</p>
                        <CssTextField
                            id='custom-css-outlined-input0'
                            label='Username / Email'
                            onChange={e => validateFormUserName(e.target.value)}
                            variant='outlined'
                            color='secondary'
                            aria-label='UserName'
                            type='text'
                            sx={{ mb: 3 }}
                            fullWidth
                            value={userName}
                            error={!!userNameError}
                            helperText={userNameErrorMsg}
                        />
                    </>
                    :
                    <>
                        <p className='p-class marginbottom24'> {LOG_IN_TITLE}</p>
                        <CssTextField
                            id='custom-css-outlined-input1'
							className='marginbottom24'
                            label='Username / Email'
                            onChange={e => validateFormUserName(e.target.value)}
                            variant='outlined'
                            color='secondary'
                            type='text'
                            aria-label='User Name'
                            sx={{ mb: 3 }}
                            fullWidth
                            value={userName}
                            error={!!userNameError}
                            helperText={userNameErrorMsg}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        {userNameError ? <img src={WarningTriangle} className='error-icon' /> : null}
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <CssTextField
                            id='custom-css-outlined-input2'
							className='marginbottom24'
                            label='Password'
                            onChange={e => validateFormPassword(e.target.value)}
                            variant='outlined'
                            color='secondary'
                            type='password'
                            value={password}
                            error={!!passwordError}
                            helperText={passwordErrorMsg}
                            autoComplete='on'
                            fullWidth
                            sx={{ mb: 3 }}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position='end'>
                                        {passwordError ? <img src={WarningTriangle} className='error-icon' /> : null}
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <p className='forgotPassword marginbottom24' onClick={() => { handleForgotPassword() }}>{FORGOT_PASSWORD}</p>
                        {loginErrorMsg && (
							<p className='warning-msg marginbottom24'>{loginErrorMsg}</p>
						)}
                    </>
                }

				{!userNameCard &&
                       <p className='login-terms marginbottom24'> {PRIVACY_POLICY_CONTENT.AGREE} <b className='termsandpolicy' onClick={privacyPolicyHandler} >{PRIVACY_POLICY_CONTENT.PRIVACY_POLICY_LABEL}</b> {PRIVACY_POLICY_CONTENT.AND} <b className='termsandpolicy' onClick={termsOfUseHandler}>{PRIVACY_POLICY_CONTENT.TERMS_OF_USE_LABEL}</b></p>
				}

                <button
                    style={{ ...buttonStyle, ...{ backgroundColor: '#00563C', color: 'white' } }}
                    variant='outlined' type='submit' className='marginbottom24'>{!userNameCard ? LOG_IN : NEXT_TEXT}</button>

                {!userNameCard ?
                    <>
                        <button style={buttonStyle} variant='outlined' onClick={navigateToGetStartedPage} type='button'>{GETTING_STARTED}</button>
                    </>
                    :
                    <>
                        <button variant='outlined' type='button' className='form-container--secondaryButton margin0' onClick={() => setUserNameCard(false)}>{BACK_TEXT}</button>
                    </>}

            </form>
        </CardContent>
    );

    const userAccountList = (landingStyle) => {
        return (
            <div className={landingStyle ? 'content-leftPanel' : ''}>
                {landingStyle ? <>
                    <p>{LOGIN_VERBIAGE}</p>
                </>
                    : ''}
                <p>{LOGIN_SUB_TEXT}</p>
            </div>
        )
    }


    const getAggregratorView = (orgName) => {
        if (orgName === 'otter') {
            return <LoginOtter />
        } else if (orgName === 'iacm') {
            return <LoginIACM />
        } else {
            return null;
        }
    }

    return (
        <>
            {orgName ? getAggregratorView(orgName)
                :
                <Container fluid data-testid='test-id' className='vh-100 d-flex flex-column '>
                    <Row className='h-100'>
                        <Col className='background-white-class'>
                            <Row className='margin_Panel'>
                            </Row>
                            <Row>
                                <Col xs={14}>
                                    <div className='landing-logo-holder aligncenter'>
                                        <img src={sevenNowLogo} className='img-right-align' alt='SevenNow header Logo' />
                                        <h2 className='merchant-title1'> {MERCHANT_PORTAL_TEXT}</h2>
                                    </div>
                                    {userAccountList(true)}
                                </Col>
                            </Row>
                        </Col>
                        <Col className='cont-background'>
                            <Row className='margin_Panel'>
                            </Row>
                            <Row>
                                <Col xs={2} >
                                </Col>
                                <Col xs={8}>
                                    <Card variant='outlined' className='cont-min-class2' style={{width: '380px'}}>{card}</Card>
                                </Col>
                                <Col xs={2}>
                                </Col>
                            </Row>
                        </Col>
                    </Row >
                </Container >}


            <CustomPopOver
                title={popOverTitle}
                descriptionContent={merchantAccountView}
                selectedValue={selectedValue}
                open={open}
                listHeight={listHeight}
                showLowerDescription={showLowerDescription}
                listTitle={listTitle}
                listData={listData}
                listControl={listControl}
                listSelectAll={true}
                primaryButton={primaryButtonText}
                onClose={handleClose}
            />

            {apiInProgress === true ?
                <div className='loader-style'><CircularProgressLoader /></div> : null}
        </>
    )
}

export default Landing;
